import { Select, styled } from '@innowise-group/mui-kit';

export const EmployeeSelect = styled(Select)`
  &.MuiAutocomplete-root,
  & .MuiTextField-root {
    width: 100%;
  }
`;
